import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, useNavigate, Link } from 'react-router-dom';
import { getDonationUserInfo, sendDonation, getProfileData } from '../services/api';
import Avatar from './Avatar';
import pointsIcon from '../assets/points_icon.png';
import '../App.css';

export default function DonatePage() {
    const { userId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const isStreamMode = searchParams.get('stream') !== null;

    const [receiver, setReceiver] = useState(null);
    const [sender, setSender] = useState(null); // Текущий залогиненный юзер
    const [amount, setAmount] = useState('');
    const [message, setMessage] = useState('');
    const [useTts, setUseTts] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);

    const token = localStorage.getItem('hatchup_token');

    useEffect(() => {
        const loadPageData = async () => {
            try {
                // 1. Загружаем инфу о получателе (публично)
                let recRes;
                if (userId.startsWith('custom')) recRes = await getDonationUserInfo(`284283073774747649`);
                else recRes = await getDonationUserInfo(userId);
                console.log(recRes);
                setReceiver(recRes.data);

                // 2. Если есть токен, загружаем инфу об отправителе
                if (token) {
                    const sendRes = await getProfileData();
                    setSender(sendRes.data);

                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        loadPageData();
    }, [userId, token]);

    const handleDonate = async (e) => {
        e.preventDefault();
        setSending(true);
        try {
            let isCustom = false;
            if (userId.startsWith('custom')) isCustom = true;
            else isCustom = false;
            await sendDonation({
                receiverId: userId,
                amount: parseInt(amount),
                message,
                isTts: useTts,
                isStreamContext: isStreamMode,
                isCustom: isCustom
            });
            alert('Донат успешно отправлен!');
            setAmount(''); setMessage(''); setUseTts(false);
        } catch (err) {
            alert(err.response?.data?.error || 'Ошибка при отправке');
        } finally { setSending(false); }
    };

    if (loading) return <div className="screen-loader">Загрузка Hatchup Donate...</div>;

    // --- СЦЕНАРИЙ 1: ПОЛЬЗОВАТЕЛЬ НЕ ЗАЛОГИНЕН ---
    if (!token) {
        return (
            <div className="donate-page-container">
                <div className="donate-card auth-error">
                    <div className="error-icon">🚫</div>
                    <h2>Вход не выполнен</h2>
                    <p>Для отправки поинтов необходимо авторизоваться в системе HATCHUP POINTS.</p>
                    <button
                        className="login-button"
                        onClick={() => navigate(`/login?redirect=${encodeURIComponent(window.location.href)}`)}
                    >
                        Войти в аккаунт
                    </button>
                </div>
            </div>
        );
    }

    if (!receiver || !receiver.donationsEnabled) {
        return (
            <div className="donate-page-container">
                <div className="donate-card">
                    <p>Этот пользователь отключил приём донатов.</p>
                </div>
            </div>
        );
    }
    // --- СЦЕНАРИЙ 2: ВСЁ ХОРОШО ---
    return (
        <div className="donate-page-container">
            <div className="donate-card">
                {/* Информация о текущей сессии */}
                <div className="sender-badge">
                    <span>Вы вошли как:</span>
                    <strong>{sender?.user.serverNickname || sender?.user.username}</strong>
                </div>

                <div className="receiver-header">
                    <Avatar user={receiver} size="lg" className="avatar-large" />
                    <h2>Поддержать {receiver.serverNickname || receiver.username}</h2>
                </div>

                {isStreamMode && (
                    <div className="stream-tag">📺 Ваше сообщение покажется на стриме</div>
                )}

                <form onSubmit={handleDonate} className="donate-form-web">
                    <div className="amount-input-wrapper-web">
                        <label>Сумма поинтов</label>
                        <div className="input-with-icon-web">
                            <input
                                type="number"
                                placeholder={`Минимум ${receiver.minDonation}`}
                                value={amount}
                                onChange={e => setAmount(e.target.value)}
                                required
                                min={receiver.minDonation}
                            />
                            <img src={pointsIcon} alt="pts" className="icon-input" />
                        </div>
                        {sender && (
                            <span className="available-balance">На балансе: {sender.totalPoints || 0} pts</span>
                        )}
                    </div>

                    <div className="message-input-wrapper">
                        <label>Ваше сообщение</label>
                        <textarea
                            placeholder="Напишите что-нибудь приятное..."
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                            maxLength={200}
                        />
                    </div>

                    {/* ЛОГИКА TTS: Показываем чекбокс только если режим стрима И сумма >= лимита */}
                    {isStreamMode && (
                        <div className="tts-toggle-row">
                            <label className="checkbox-container">
                                <input
                                    type="checkbox"
                                    checked={useTts}
                                    onChange={e => setUseTts(e.target.checked)}
                                    disabled={parseInt(amount) < receiver.minTtsDonation || !amount}
                                />
                                <span className="checkmark"></span>
                                <span className="label-text">Озвучить сообщение (от {receiver.minTtsDonation} поинтов) 🎙️</span>
                            </label>
                        </div>
                    )}

                    <button type="submit" disabled={sending || !amount} className="donate-btn-primary">
                        {sending ? 'Отправка...' : 'Отправить донат'}
                    </button>
                </form>
            </div>
        </div>
    );
}